"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _editModel = _interopRequireDefault(require("./components/editModel"));
var _viewToken = _interopRequireDefault(require("./components/viewToken"));
var _authInfo = _interopRequireDefault(require("./components/authInfo"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    editModel: _editModel.default,
    viewToken: _viewToken.default,
    authInfo: _authInfo.default
  },
  data: function data() {
    return {
      pageName: 'interfaceuser',
      listLoading: false,
      list: [],
      total: 0,
      currentId: null,
      isShowModel: false,
      isShowViewTokenModel: false,
      isShowAuthInfoModel: false,
      currPage: 1,
      limit: 10,
      searchVal: {
        userName: ''
      },
      dialogStatus: 'create',
      form: {
        userPk: '',
        userName: '',
        loginCode: '',
        userMobile: '',
        remark: '',
        token: ''
      },
      userType: {},
      expandRowKeys: []
    };
  },
  mounted: function mounted() {
    this.fetchData();
    this.getUserType();
  },
  methods: {
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchData: function fetchData() {
      var _this = this;
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: {
          userName: this.searchVal.userName
        }
      };
      this.listLoading = true;
      this.$api.interfaceuser.getInterfaceUserList(param).then(function (res) {
        _this.listLoading = false;
        _this.list = res.data.items;
        _this.total = res.data.totalCount;
      }).catch(function (err) {
        console.log('-------', err);
        _this.listLoading = false;
      });
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    },
    refreshData: function refreshData() {
      this.fetchData();
    },
    create: function create() {
      this.dialogStatus = 'create';
      this.form = {
        userPk: '',
        userName: '',
        loginCode: '',
        userMobile: '',
        remark: ''
      };
      this.isShowModel = true;
    },
    edit: function edit(row) {
      var _this2 = this;
      this.dialogStatus = 'edit';
      this.currentId = row.userPk;
      if (this.currentId === null) {
        return;
      }
      this.getDetail().then(function (res) {
        _this2.isShowModel = true;
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;
      return new Promise(function (resolve) {
        _this3.$api.interfaceuser.getInterfaceUserDetail(_this3.currentId).then(function (res) {
          var _res$data = res.data,
            userPk = _res$data.userPk,
            userName = _res$data.userName,
            loginCode = _res$data.loginCode,
            userMobile = _res$data.userMobile,
            remark = _res$data.remark;
          _this3.form = {
            userPk: userPk,
            userName: userName,
            loginCode: loginCode,
            userMobile: userMobile,
            remark: remark
          };
          resolve(_this3.form);
        }).catch(function () {
          console.log('Data Request Fail');
        });
      });
    },
    getToken: function getToken() {
      var _this4 = this;
      return new Promise(function (resolve) {
        _this4.$api.interfaceuser.viewTokenInterfaceUser(_this4.currentId).then(function (res) {
          var _res$data2 = res.data,
            loginCode = _res$data2.loginCode,
            userName = _res$data2.userName,
            token = _res$data2.token;
          _this4.form = {
            loginCode: loginCode,
            userName: userName,
            token: token
          };
          resolve(_this4.form);
        }).catch(function () {
          console.log('Data Request Fail');
        });
      });
    },
    resetToken: function resetToken(row) {
      var _this5 = this;
      this.$confirm(this.$t('common.confirm7'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this5.$api.interfaceuser.resetTokenInterfaceUser([row.userPk]).then(function (res) {
          _this5.$message.success(_this5.$t('common.resetSuccess'));
        }).catch(function () {
          // this.$message.error('重置失败')
        });
      }).catch(function () {});
    },
    handleClick: function handleClick(row) {
      console.log('---------', row);
      this.isShowAuthInfoModel = true;
    },
    userAuth: function userAuth(row) {
      this.currentId = row.userPk;
      if (this.currentId === null) {
        return;
      }
      this.expandRowKeys.push(row.userPk);
      this.isShowAuthInfoModel = true;
    },
    viewToken: function viewToken(row) {
      var _this6 = this;
      this.dialogStatus = 'edit';
      this.currentId = row.userPk;
      if (this.currentId === null) {
        return;
      }
      this.getToken().then(function (res) {
        _this6.isShowViewTokenModel = true;
      });
    },
    disableInterfaceUser: function disableInterfaceUser(row) {
      var _this7 = this;
      this.$confirm(this.$t('common.confirm8'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this7.$api.interfaceuser.disableInterfaceUser([row.userPk]).then(function (res) {
          _this7.$message.success(_this7.$t('common.disabledSuccess'));
          _this7.refreshData();
        }).catch(function () {
          // this.$message.error('禁用失败')
        });
      }).catch(function () {});
    },
    enableInterfaceUser: function enableInterfaceUser(row) {
      var _this8 = this;
      this.$confirm(this.$t('common.confirm9'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this8.$api.interfaceuser.enableInterfaceUser([row.userPk]).then(function (res) {
          _this8.$message.success(_this8.$t('common.enableSuccess'));
          _this8.refreshData();
        }).catch(function () {
          // this.$message.error('启用失败')
        });
      }).catch(function () {});
    },
    deleteInterfaceUser: function deleteInterfaceUser(row) {
      var _this9 = this;
      this.$confirm(this.$t('common.confirm10'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this9.$api.interfaceuser.deleteInterfaceUser([row.userPk]).then(function (res) {
          _this9.$message.success(_this9.$t('common.deleteSuccess'));
          _this9.refreshData();
        }).catch(function () {
          // this.$message.error('删除失败')
        });
      }).catch(function () {});
    },
    getUserType: function getUserType() {
      var _this0 = this;
      this.$api.lookup.getLookupTypeCodeDetail('LPT_USER_TYPE').then(function (res) {
        _this0.userType = {};
        if (res.data && res.data.length > 0) {
          res.data.forEach(function (item) {
            _this0.userType[item.valueCode] = item.valueName;
          });
        }
      }).catch(function () {});
    },
    formatterUserType: function formatterUserType(row, column, cellValue, index) {
      return this.userType[cellValue] || cellValue;
    },
    expandChange: function expandChange(row, expanded) {
      var index = this.expandRowKeys.indexOf(row.userPk);
      if (index >= 0) {
        // 收起当前行
        this.expandRowKeys.splice(index, 1);
      } else {
        this.expandRowKeys.push(row.userPk);
      }
    }
  }
};